/**
 * Delivery Estimation
 * Calcule la date d'expedition (cutoff + jours ouvres) puis la date de livraison.
 * Fuseau Europe/Paris.
 */
(function () {
  'use strict';

  var containers = document.querySelectorAll('.delivery-estimation');
  if (!containers.length) return;

  containers.forEach(function (container) {
    var cutoff = parseInt(container.dataset.cutoff, 10);
    var shipsSaturday = container.dataset.shipsSaturday === 'true';
    var daysMax = parseInt(container.dataset.daysMax, 10);
    var isClosed = container.dataset.closed === 'true';
    var badgeText = container.dataset.badgeText || '';

    if (isClosed) {
      container.style.display = 'none';
      return;
    }

    var DAYS_FULL = ['dimanche', 'lundi', 'mardi', 'mercredi', 'jeudi', 'vendredi', 'samedi'];
    var MONTHS_FULL = ['janvier', 'février', 'mars', 'avril', 'mai', 'juin', 'juillet', 'août', 'septembre', 'octobre', 'novembre', 'décembre'];
    var MONTHS_ABBR = ['jan.', 'fév.', 'mars', 'avr.', 'mai', 'juin', 'juil.', 'août', 'sept.', 'oct.', 'nov.', 'déc.'];

    function nowParis() {
      var now = new Date();
      var parisStr = now.toLocaleString('fr-FR', { timeZone: 'Europe/Paris' });
      var parts = parisStr.split(' ');
      var dateParts = parts[0].split('/');
      var timeParts = parts[1].split(':');
      var parisDate = new Date(
        parseInt(dateParts[2], 10),
        parseInt(dateParts[1], 10) - 1,
        parseInt(dateParts[0], 10)
      );
      return { date: parisDate, hour: parseInt(timeParts[0], 10), day: parisDate.getDay() };
    }

    function isBusinessDay(dayOfWeek) {
      if (dayOfWeek === 0) return false;
      if (dayOfWeek === 6) return shipsSaturday;
      return true;
    }

    function nextBusinessDay(date) {
      var d = new Date(date);
      do { d.setDate(d.getDate() + 1); } while (!isBusinessDay(d.getDay()));
      return d;
    }

    function addDays(date, n) {
      var d = new Date(date);
      d.setDate(d.getDate() + n);
      return d;
    }

    function formatFull(date) {
      return DAYS_FULL[date.getDay()] + ' ' + date.getDate() + ' ' + MONTHS_FULL[date.getMonth()];
    }

    function formatDayMonth(date) {
      return date.getDate() + ' ' + MONTHS_ABBR[date.getMonth()];
    }

    var paris = nowParis();
    var today = paris.date;
    var shipDate;

    if (paris.hour < cutoff && isBusinessDay(paris.day)) {
      shipDate = today;
    } else {
      shipDate = nextBusinessDay(today);
    }

    var deliveryDate = addDays(shipDate, daysMax);

    var headerEl = container.querySelector('[data-delivery-header]');
    if (headerEl) {
      var headerHtml = 'Livraison estimée à <strong>' + formatFull(deliveryDate) + '</strong>';
      if (badgeText) { headerHtml += ' — ' + badgeText; }
      headerEl.innerHTML = headerHtml;
    }

    var orderDateEl = container.querySelector('[data-delivery-order-date]');
    var shipDateEl = container.querySelector('[data-delivery-ship-date]');
    var arriveDateEl = container.querySelector('[data-delivery-arrive-date]');

    if (orderDateEl) orderDateEl.textContent = formatDayMonth(today);
    if (shipDateEl) shipDateEl.textContent = formatDayMonth(shipDate);
    if (arriveDateEl) arriveDateEl.textContent = formatDayMonth(deliveryDate);
  });
})();
